import { Skeleton } from '@/components/ui/skeleton';

/** Skeleton com a forma do conteúdo (`spec/17` §7 item 6), não um bloco cinza genérico. */
export function TableSkeleton({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  const rowIds = Array.from({ length: rows }, (_, index) => `row-${index}`);
  const columnIds = Array.from({ length: columns }, (_, index) => `col-${index}`);
  return (
    <div className="flex flex-col gap-2" role="status" aria-busy="true" aria-label="Carregando">
      {rowIds.map((rowId) => (
        <div key={rowId} className="flex gap-3">
          {columnIds.map((columnId) => (
            <Skeleton key={columnId} className="h-9 flex-1 rounded-control" />
          ))}
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ lines = 3 }: { lines?: number }) {
  const lineIds = Array.from({ length: lines }, (_, index) => `line-${index}`);
  return (
    <div
      className="flex flex-col gap-3 rounded-card border border-card-border bg-card p-5"
      role="status"
      aria-busy="true"
      aria-label="Carregando"
    >
      <Skeleton className="h-3 w-24 rounded-control" />
      <Skeleton className="h-9 w-40 rounded-control" />
      {lineIds.map((lineId) => (
        <Skeleton key={lineId} className="h-3 w-full rounded-control" />
      ))}
    </div>
  );
}
